import { render, staticRenderFns } from "./ProductInfor.vue?vue&type=template&id=266e820a&scoped=true&"
import script from "./ProductInfor.vue?vue&type=script&lang=js&"
export * from "./ProductInfor.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfor.vue?vue&type=style&index=0&id=266e820a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266e820a",
  null
  
)

export default component.exports